export default __webpack_public_path__ + "static/media/9.65720295.webp";